import * as React from 'react'
import Logo from 'proposals/components/Logo'
import PageTitle from 'proposals/components/PageTitle'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import HankintaLogo from 'proposals/components/HankintaLogo'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Box } from '@mui/material'
import Button from '@mui/material/Button'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

type ViewHeaderProps = {
  logoUrl?: string
  title: string
  onBack?: () => void
}

const ViewHeader: React.FC<ViewHeaderProps> = ({
  title,
  logoUrl = '/images/default_logo.png',
  onBack
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const isWidescreen = useMediaQuery(theme.breakpoints.up('md'))

  const backButton = onBack ? (
    <Button
      onClick={onBack}
      startIcon={<ArrowBackIcon sx={{ p: 0 }} />}
      sx={{ color: 'text.secondary', alignSelf: 'flex-start', px: 1, padding: 0 }}
    >
      {t('back')}
    </Button>
  ) : null

  return (
    <>
      <Box
        sx={{
          gridArea: 'logo',
          display: isWidescreen ? 'flex' : 'none',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }}
      >
        <Logo src={logoUrl} />
        {isWidescreen && backButton && <Box sx={{ mt: 1 }}>{backButton}</Box>}
      </Box>
      <PageTitle>
        {!isWidescreen && backButton && <Box sx={{ mb: 1 }}>{backButton}</Box>}
        <Typography variant="h6" color="textSecondary" sx={{ fontWeight: 400 }}>
          {t('request-for-proposal')}
        </Typography>
        <Typography sx={{ fontWeight: 'fontWeightLight', lineHeight: 1 }} variant="h4" component="h1">
          {title}
        </Typography>
      </PageTitle>
      <Box sx={{ gridArea: 'brand', display: isWidescreen ? 'flex' : 'none', justifyContent: 'flex-end' }}>
        <HankintaLogo />
      </Box>
    </>
  )
}

export default ViewHeader
